import React from 'react';

const CurrencyIcon = ({ width = '1em', height = '1em', style = {} }: { width?: number | string; height?: number | string; style?: React.CSSProperties }) => {
    return (
        <img
            src={"/static/images/dhiram.png"}
            style={{
                width: typeof width === 'number' ? `${width}px` : width,
                height: typeof height === 'number' ? `${height}px` : height,
                verticalAlign: "middle",
                display: "inline-block",
                marginRight: "0.15em",
                objectFit: "contain",
                ...style
            }}
        />
    );
};

export default CurrencyIcon;